module.exports = __webpack_public_path__ + "static/media/aldi.447707a0.png";